import {
  BettorLeaderboard,
  PaginatedResponse,
  ApiResponse,
  Sport,
  BettorMetricsTimeframe,
  BettorLeaderboardOrder,
  BettorNewLeaderboard,
  SportType,
  PickType,
  OddOutcome,
  LineType,
  Odd2,
  RecentPick,
  getPickAlignment,
  pickTypeToLineType,
} from "common";
export type Pick = {
  id: number;
  sportType: SportType;
  type: PickType;
  outcome: OddOutcome;
  unitsGained: number;
  createdAt: string;
  comment?: string;
  oddValue?: number;
  oddPayout: number;
  opposingOddPayout: number;
}
export function pickToOdd(pick: Pick): Odd2 {
  return {
    type: pickTypeToLineType(pick.type),
    alignment: getPickAlignment(pick.type),
    value: pick.oddValue,
    payout: pick.oddPayout,
  };
}
export function pickToOpposingOdd(pick: Pick): Odd2 {
  return {
    type: pickTypeToLineType(pick.type),
    alignment: getPickAlignment(pick.type) === 0 ? 1 : 0,
    value: pick.oddValue ? -pick.oddValue : undefined,
    payout: pick.opposingOddPayout,
  };
}
// export async function getPickActivityByGame(
//   sport: Sport,
//   id: number,
// ) {
//   const baseUrl = `${process.env.NEXT_PUBLIC_API_URL}/sports/${sport}/games/${id}/pick-activity`;
//   const params: URLSearchParams = new URLSearchParams();
//   params.append("sport", sport);
//   if (team) {
//     params.append("team", team);
//   }
//   const request: string = `${baseUrl}?${params}`;
//   const res = await fetch(request, {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     cache: "no-store",
//   });
//   if (!res.ok) {
//     throw new Error("Failed to fetch games with pick activity");
//   }
//   return res.json();
// }
export async function getPickActivity(
  sport: Sport,
  date: string,
  team?: string
) {
  const baseUrl = `${process.env.NEXT_PUBLIC_API_URL}/api/sports/game-pick-activity/${date}`;
  const params: URLSearchParams = new URLSearchParams();
  params.append("sport", sport);
  if (team) {
    params.append("team", team);
  }
  const request: string = `${baseUrl}?${params}`;
  const res = await fetch(request, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    cache: "no-store",
  });
  if (!res.ok) {
    throw new Error("Failed to fetch games with pick activity");
  }
  return res.json();
}
export async function getRecentPicks(user_id: string) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/client/bettor-recent-picks/${user_id}/`,
    {
      cache: "no-store",
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch recent picks");
  }

  const data = await res.json();
  return data;
}

export async function getPickHistory(username: string) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/client/bettor-historical-picks/${username}`
  );
  if (res.status === 404) {
    return [];
  }
  if (!res.ok) {
    throw new Error("Failed to fetch historical picks");
  }
  return res.json();
}

export async function getTopPickers(limit?: number) {
  const baseUrl = `${process.env.NEXT_PUBLIC_API_URL}/api/users/top-pickers`;
  const params: URLSearchParams = new URLSearchParams();
  if (limit) {
    params.append("limit", `${limit}`);
  }
  const request: string = `${baseUrl}?${params}`;
  const res = await fetch(request);
  if (res.status === 404) {
    return [];
  }
  if (!res.ok) {
    throw new Error("Failed to fetch top pickers");
  }
  return res.json();
}
// export async function getLeaderboard(sport: Sport, window: string, limit?: number): Promise<ApiResponse<PaginatedResponse<BettorLeaderboard>>> {
//   const baseUrl = `${process.env.NEXT_PUBLIC_API_URL}/api/sports/${sport}/leaderboard`;
//   const params: URLSearchParams = new URLSearchParams();
//   if (limit) {
//     params.append("limit", `${limit}`);
//   }
//   if (window !== "all") {
//     params.append("window", window);
//   }
//   const request: string = `${baseUrl}?${params}`;
//   // console.log("leaderboard request:", request);
//   const res = await fetch(
//     request, {
//       headers: {
//         'Accept': 'application/json',
//       },
//       cache: "no-store"
//     }
//   );
//   // console.log("leaderboard response:", await res.json());
//   if (res.status === 404) {
//     return {status: "error", message: "No leaderboard data found."};
//   }
//   if (!res.ok) {
//     throw new Error("Failed to fetch leaderboard");
//   }
//   const data: PaginatedResponse<BettorLeaderboard> = await res.json();
//   return { status: "success", data };
// }

export async function getLeaderboard(
  sport: Sport = "all",
  timeframe: BettorMetricsTimeframe = "last25Games",
  limit: number = 25,
  page: number = 1,
  order: BettorLeaderboardOrder = "total_units_gained_desc",
): Promise<BettorNewLeaderboard> {
  const baseUrl = `${process.env.NEXT_PUBLIC_API_URL}/bettors/leaderboard`;
  const params: URLSearchParams = new URLSearchParams();
  params.append("timeframe", `${timeframe}`);
  params.append("limit", `${limit}`);
  params.append("page", `${page}`);
  params.append("order", order);
  if (sport !== "all") {
    params.append("sport", sport);
  }
  const request: string = `${baseUrl}?${params}`;
  const res = await fetch(request, {
    headers: {
      Accept: "application/json",
    },
    cache: "no-store",
  });
  if (!res.ok) {
    throw new Error("Failed to fetch leaderboard");
  }
  const data: BettorNewLeaderboard = await res.json();
  return data;
}
